<template>
  <div class="system-campaigns-list vx-row mb-6">
    <div class="vx-col w-full">
      <!-- desktop version -->
        <div class="grid md:grid-cols-3 gap-4">
          <div class="campaigns-list-search-input-parent">
            <vs-icon class="campaigns-search-icon" icon-pack="speakol" icon="speakol-search"></vs-icon>
            <input id="system-campaigns-campaigns-list-search-input" class="w-full campaigns-list-search-input" type="text" placeholder="Search" v-model="filters.name" />
          </div>
          <div>
            <treeselect id="system-campaigns-campaigns-list-status-list" :options="options.status" v-model="filters.status" placeholder="Status"></treeselect>
          </div>
          <div>
            <treeselect id="system-campaigns-campaigns-list-status-list" :options="options.deliveringStatus" v-model="filters.deliveringStatus" placeholder="Delivering Status"></treeselect>
          </div>
          <div>
            <treeselect id="system-campaigns-campaigns-list-managers-list" :options="options.managers" v-model="filters.manager" placeholder="Managers"></treeselect>
          </div>
          <div>
            <speakol-tree-select
              id="system-campaigns-campaigns-list-email-list"
              placeholder="User Email"
              validation="required|email"
              :fetchFunction="fuzzySearch"
              :transformationFunction="transformationFunction"
              ref="email"
              @input="handleAccountSelected"
            >
            </speakol-tree-select>
          </div>
          <div>
              <treeselect
              id="system-campaigns-campaigns-list-campaign-types-list"
              :options="options.campaignTags"
              v-model="filters.campaignTag"
              placeholder="All Campaigns"
            >
            </treeselect>
          </div>
          <div>
            <treeselect id="system-campaigns-campaigns-list-objectives-list" :options="options.objectives" v-model="filters.objective" placeholder="Objectives"></treeselect>
          </div>
          <div>
            <treeselect id="system-campaigns-campaigns-list-types-list" :options="options.types" v-model="filters.type" placeholder="Types"></treeselect>
          </div>
        </div>

        <div class="text-right pt-2">
          <vs-button id="system-campaigns-campaigns-list-filter-button" class="shadow-none speakol-table-filter-button" @click="$emit('filter-campaigns', filters)">
            {{ $t('Filter') }}
          </vs-button>
        </div>
      <!-- desktop version -->
    </div>

    <!-- <SpeakolExport :isActive="isExportPopupActive" exportType="admin-campaigns" :params="{...$parent.agFilters, is_admin: 1}" @hide="isExportPopupActive=false" /> -->
  </div>
</template>

<script>
import { Treeselect, ASYNC_SEARCH } from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import campaignStatus from '@/views/campaigns/campaignStatus.js'

// import SpeakolExport from  '@/components/SpeakolExport'
import  { isEmpty, get, compact } from 'lodash'


export default {
  components: {
    // SpeakolExport,
    Treeselect
  },
  props: ['tag'],

  data () {
    return {
      // isExportPopupActive: false,
      options: {
        status: this.getCampaignStatuses(),
        managers: [],
        campaignTags: [
          { id: 'premium', label: 'Premium Campaigns' },
          { id: 'standard', label: 'Standard Campaigns' }
        ],
        deliveringStatus: [
          { id: 1, label: 'Delivering' },
          { id: 2, label: 'Not Delivering' }
        ],
        objectives: [],
        types: []
      },

      filters: {
        name: null,
        status: null,
        manager: null,
        advertiser: null,
        accountId:null,
        campaignTag: this.tag,
        deliveringStatus: null,
        objective: null,
        type: null
      },

      stateModal: {
        type: 'error',
        show: false,
        body: 'Error message'
      }
    }
  },
  async created () {
    await this.fetchAccountManagers()
    await this.getCampaignsObjectives()
    await this.getCampaignsTypes()
  },

  methods: {
    handleAccountSelected (accountId) {
      this.filters.accountId = accountId || null
    },
    async fuzzySearch (searchQuery) {
      const { data } = await window.axios.get(`/users/${searchQuery}/accounts/personal/sub`)
      return data.filter((obj) => !isEmpty(obj.personal_and_subaccounts))
    },
    transformationFunction (user) {
      const userId = user.id
      const userEmail = user.email
      const userAccounts = user.personal_and_subaccounts
      return {
        id: userId,
        label: userEmail,
        children: userAccounts.map((account) => {
          const accountName = account.name
          const accountId = account.id
          return {
            id: accountId,
            label: accountName,
            account,
            user
          }
        })
      }
    },
    getCampaignStatuses () {
      return campaignStatus.map((status) => {
        return {
          id: status,
          label: status
        }
      })
    },
    async fetchAccountManagers () {
      const response = await window.axios.get('/users/managers')

      this.options.managers = response.data.map((item) => {
        return {
          id: item.id,
          label: item.name
        }
      })
    },
    async fetchAdvertisers ({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        let options = []
        if (searchQuery.length >= 3) {
          const response = await window.axios.get('/users/advertisers', {
            params: {
              name: searchQuery
            }
          })

          options = response.data.map(item => {
            return {
              id: item.id,
              label: item.name
            }
          })
        }
        callback(null, options)
      }
    },
    handleObjectivesAndTypesDisplayedData (payload) {
      if (!payload || !payload.length) {
        return []
      }

      return compact(payload.map((item) => {
        if (item.is_active !== 1) {
          return
        }

        return {
          id: item.id,
          label: item.display_name
        }
      }))
    },
    async getCampaignsObjectives () {
      const response = await window.axios.get('/recommendations/get/objectives'),
        payload = get(response, 'data.payload', [])
      this.options.objectives = this.handleObjectivesAndTypesDisplayedData(payload)
    },
    async getCampaignsTypes () {
      const response = await window.axios.get('/recommendations/get/display_types'),
        payload = get(response, 'data.payload', [])
      this.options.types = this.handleObjectivesAndTypesDisplayedData(payload)
    }
  }
}
</script>

<style lang="scss">
  .system-campaigns {
    .speakol-table-filter-button {
      width: 135px;
    }

    .speakol-export-button {
      background-color: white !important;
      color: #0092d7;
      border: 1px solid #0092d7;
      width: 135px;
      border-radius: 3px;
      padding: 8px 20px !important;
    }
  }

  .vue-tabs .nav > li > a:hover,
  .vue-tabs .nav > li > a:focus {
    background-color: transparent !important;
  }

  .tab.active h4 {
    font-weight: 500 !important;
  }

  .vue-treeselect__control {
    height: 38px !important;
  }

  .vs-input--input.hasIcon {
    border: 1px solid #cfcfcf !important;
  }

  .vs-input--input.hasIcon:focus {
    box-shadow: none !important;
  }

  .speakol-table-input .vs-con-input .vs-icon {
    color: #cfcfcf !important;
  }

  .accounts-tree-select {
    width: 200px;
    margin-top: -11px;
  }

  @media (max-width: 768px) {
    .speakol-table-filter-button {
      width: 100% !important;
      margin-top: 7px;
    }

    .vue-treeselect__menu {
      width: inherit !important;
    }
  }

  @media (min-width: 1453px) {
    .vue-treeselect__menu {
      width: 100% !important;
    }
  }

  .campaign-name {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 150px;
    white-space: nowrap;
  }

  .system-campaigns-list {
    .vue-treeselect__label {
      overflow: visible;
      text-overflow: unset;
    }

    .vue-treeselect__menu {
      width: 369px;
      overflow-x: auto;
    }

    .tree-select-count {
      float: none !important;
    }

    .tree-select-email {
      width: auto;
    }

    .vue-treeselect__option--highlight {
      background: #fff !important;
    }
  }

  .campaigns-list-search-input-parent {
    position: relative;

    ::placeholder {
      color: #bdbdbd;
      font-weight: 500;
    }

    .campaigns-list-search-input {
      height: 38px;
      border: 1px solid #ddd;
      border-radius: 4px;
      text-indent: 30px;
    }

    .campaigns-search-icon {
      position: absolute;
      top: 8px;
      left: 6px;
      color: #ddd;
    }
  }
</style>
